import type { Dispatch, SetStateAction } from 'react'
import { makeEmptyRow, type ItemRow } from '../components/ItemsTable'

// Редактирование таблицы позиций на странице «Новая заявка». Вынесено из
// NewRequestPage (≤500 строк), логика не менялась.
//
// updateItem/deleteItem получают idx в массиве, который ItemsTable рендерит.
// При активном фильтре это displayedItems (а не items), индексы расходятся
// — мапим через uid обратно на оригинальный массив.
export function useItemRowsEditor(
  setItems: Dispatch<SetStateAction<ItemRow[]>>,
  displayedItems: ItemRow[],
) {
  const updateItem = (idx: number, field: string, value: string | number | boolean) => {
    const uid = displayedItems[idx]?.uid
    if (!uid) return
    setItems((prev) => prev.map((row) => (row.uid === uid ? { ...row, [field]: value } : row)))
  }

  const deleteItem = (idx: number) => {
    const uid = displayedItems[idx]?.uid
    if (!uid) return
    setItems((prev) => {
      const next = prev.filter((row) => row.uid !== uid)
      return next.length === 0 ? [makeEmptyRow()] : next
    })
  }

  const addRow = () => setItems((prev) => [...prev, makeEmptyRow()])

  // Перестановка позиций через drag-and-drop. Порядок здесь — единственный
  // источник правды: при создании заявки уйдёт ровно так, как менеджер выставил.
  const reorderItems = (fromIdx: number, toIdx: number) => {
    setItems((prev) => {
      if (fromIdx === toIdx || fromIdx < 0 || toIdx < 0) return prev
      if (fromIdx >= prev.length || toIdx >= prev.length) return prev
      const next = prev.slice()
      const [moved] = next.splice(fromIdx, 1)
      if (!moved) return prev
      next.splice(toIdx, 0, moved)
      return next
    })
  }

  // Очистить только заметки всех позиций — не трогая сам список.
  const clearNotes = () => {
    setItems((prev) => prev.map((row) => ({ ...row, note: '' })))
  }

  return { updateItem, deleteItem, addRow, reorderItems, clearNotes }
}
